/*
  Asama product page behaviour. Dawn's product-info, product-form, media-gallery
  and slider-component do the real work; this file drives the mobile sticky add
  to cart bar (snippets/asama-pdp-sticky-atc.liquid) and the PIN code delivery
  check (snippets/asama-pdp-pincode.liquid).
*/
(() => {
  const initBar = (bar) => {
    const sectionId = bar.dataset.section;
    const anchor = document.getElementById(`AsamaBuyBox-${sectionId}`);
    if (!anchor) return;

    // Shown while the real button is off screen, but never on a fresh page:
    // the first thing on a phone should be the photo, not a second button.
    let buyBoxVisible = true;
    const update = () => {
      const next = buyBoxVisible || window.scrollY < 160;
      if (bar.hidden !== next) bar.hidden = next;
    };
    new IntersectionObserver(
      ([entry]) => {
        buyBoxVisible = entry.isIntersecting;
        update();
      },
      { threshold: 0 }
    ).observe(anchor);
    window.addEventListener('scroll', update, { passive: true });

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data.sectionId !== sectionId) return;

      const price = document.getElementById(`AsamaStickyPrice-${sectionId}`);
      const source = data.html.getElementById(`price-${sectionId}`);
      if (price && source) price.innerHTML = source.innerHTML;

      const button = document.getElementById(`AsamaStickyButton-${sectionId}`);
      const sourceButton = data.html.getElementById(`ProductSubmitButton-${sectionId}`);
      if (button && sourceButton) {
        button.disabled = sourceButton.hasAttribute('disabled');
        button.textContent = sourceButton.textContent.trim();
      }
    });
  };

  document.querySelectorAll('.asama-stickybar[data-section]').forEach(initBar);
})();

/*
  PIN code delivery check. See snippets/asama-pdp-pincode.liquid for why this
  answers with a destination rather than a yes/no: Asama ships everywhere in
  India, so serviceability was never the question.
*/
(() => {
  // India Post assigns the first digit of every PIN to a fixed postal region.
  // Held here so the box still answers when the lookup API is unreachable.
  const REGIONS = {
    1: 'Delhi, Haryana, Punjab, Himachal Pradesh, Jammu and Kashmir, Ladakh or Chandigarh',
    2: 'Uttar Pradesh or Uttarakhand',
    3: 'Rajasthan, Gujarat, Daman and Diu or Dadra and Nagar Haveli',
    4: 'Maharashtra, Madhya Pradesh, Chhattisgarh or Goa',
    5: 'Andhra Pradesh, Telangana or Karnataka',
    6: 'Tamil Nadu, Kerala, Puducherry or Lakshadweep',
    7: 'West Bengal, Odisha, Assam, the north east states or the Andaman and Nicobar Islands',
    8: 'Bihar or Jharkhand',
  };

  // "7 = 2 to 4 days" per line, region digit on the left. Anything the merchant
  // has not filled in simply has no estimate, which is the point.
  const parseTransit = (raw) => {
    const map = {};
    (raw || '').split('\n').forEach((line) => {
      const m = line.match(/^\s*([1-8])\s*[=:]\s*(.+?)\s*$/);
      if (m) map[m[1]] = m[2];
    });
    return map;
  };

  const initPin = (root) => {
    const input = root.querySelector('.asama-pin__input');
    const button = root.querySelector('.asama-pin__submit');
    const out = root.querySelector('.asama-pin__out');
    if (!input || !button || !out) return;

    const transit = parseTransit(root.dataset.transit);
    const dispatch = (root.dataset.dispatch || '').trim();
    const phone = (root.dataset.phone || '').trim();

    const say = (text, state) => {
      out.textContent = text;
      out.dataset.state = state;
      out.hidden = false;
    };

    // Lines are assembled rather than templated so an empty setting drops out
    // instead of leaving "Delivered in ." on the page.
    const answer = (place, digit) => {
      const lines = [`Delivers to ${place}.`];
      if (dispatch) lines.push(dispatch);
      if (transit[digit]) lines.push(`Then about ${transit[digit]} in transit.`);
      say(lines.join(' '), 'ok');
    };

    const check = async () => {
      const pin = input.value.replace(/\D/g, '');
      if (pin.length !== 6) {
        say('Enter the six digits of your PIN code.', 'ask');
        return;
      }
      const digit = pin[0];
      if (digit === '9' || digit === '0') {
        say(
          phone
            ? `That is an Army Postal Service code. Call or WhatsApp ${phone} and we will arrange it.`
            : 'That is an Army Postal Service code. Please contact us and we will arrange it.',
          'ask',
        );
        return;
      }

      say('Checking...', 'busy');
      let place = '';
      try {
        const res = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
        const [data] = await res.json();
        const office = data && data.Status === 'Success' && data.PostOffice && data.PostOffice[0];
        if (office) place = [office.District, office.State].filter(Boolean).join(', ');
      } catch (e) {
        // Falls through to the offline region name below. A lookup that is
        // down is not a reason to tell the customer their PIN is wrong.
      }
      if (place) return answer(place, digit);
      if (REGIONS[digit]) return answer(REGIONS[digit], digit);
      say('That does not look like an Indian PIN code. Check the six digits.', 'ask');
    };

    button.addEventListener('click', check);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        check();
      }
    });
    input.addEventListener('input', () => {
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
      out.hidden = true;
    });
  };

  document.querySelectorAll('[data-asama-pin]').forEach(initPin);
})();
